import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { postLogCertificaziniInfocenterAction, setDataFine, setDataInizio, setPaginaSelezionataAction } from "./actions";
import { LogCertificazioniInfocenterReducerType } from "./types";

const initialState: LogCertificazioniInfocenterReducerType = {
  logCertificazioniInfoCenter: undefined,
  paginaSelezionata: 1,
  dataInizio: moment().subtract('7', 'days').toDate(),
  dataFine: moment().toDate(),
  /*  statoCertificazione: undefined,
   modalitaCertificazione: undefined,
   ndg: undefined, */

}


export const logCertificazioniInfocenterReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setDataInizio, (state, action) => {
      state.dataInizio = action.payload;
    })
    .addCase(setDataFine, (state, action) => {
      state.dataFine = action.payload;
    })
    .addCase(postLogCertificaziniInfocenterAction.pending, (state) => {
      state.logCertificazioniInfoCenter = initialState.logCertificazioniInfoCenter
    })
    .addCase(postLogCertificaziniInfocenterAction.fulfilled, (state, action) => {
      state.logCertificazioniInfoCenter = action.payload;
    })
    .addCase(setPaginaSelezionataAction, (state, action) => {
      state.paginaSelezionata = action.payload
    })

});
